import React from 'react';
import { RichText } from '../richTextOptions';
import { Image } from './Common/Image';
import Block from '../block';

const ContentfulSectionRealCustomerStory = (props) => {
    const {
        backgroundColor,
        videoOrImage,
        storyVideo,
        storyImage,
        storyTitle,
        ownerStory,
        ownerInformation,
        healthIssueText,
        vetBillText,
        reimbursementText,
        healthIssueTitle,
        healthIssueContent,
        bottomNote
    } = props;
    const sectionStyle = backgroundColor ? { backgroundColor } : {};

    const mediaVideo = props.sys ? storyVideo : storyVideo?.storyVideo

    return (
        <section className="real-customer-story" style={sectionStyle}>
            <div className="container">
                <div className="row story-wrapper">
                    <div className="col-md-7">
                        {
                            (videoOrImage && videoOrImage === 'Video') ? (
                                <>{mediaVideo && <div className="story-media story-media-video" dangerouslySetInnerHTML={{ __html: mediaVideo }}></div>}</>
                            ) : (
                                <>{ storyImage && <div className="story-media"><Image image={storyImage} /></div>}</>
                            )
                        }
                    </div>
                    <div className="col-md-5">
                        <div className="story-content">
                            {storyTitle && <h2>{storyTitle}</h2>}
                            {ownerStory && <RichText data={ownerStory} />}
                            {ownerInformation && <span className="owner-info">{ownerInformation}</span>}
                            <div className="insurance-details">
                                <p>Health issue: {healthIssueText && <span className="highlighted-text">{healthIssueText}</span>}</p>
                                <p>Vet bill: {healthIssueText && <span className="highlighted-text">{vetBillText}</span>}</p>
                                <p>Reimbursement: {healthIssueText && <span className="highlighted-text">{reimbursementText}</span>}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="health-issue-content">
                    {healthIssueTitle && <RichText data={healthIssueTitle} />}
                    <div className="health-issue-content-wrapper">
                        {
                            Array.isArray(healthIssueContent) && healthIssueContent.map((el, i) => (
                                <div key={i} className="health-issue-content-col"><Block block={el} /></div>
                            ))
                        }
                    </div>
                </div>
                {bottomNote && <div className="health-bottom-note"><RichText data={bottomNote} /></div>}
            </div>
        </section>
    )
}

export { ContentfulSectionRealCustomerStory };
